// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

 var URLHOST = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
if(URLHOST.indexOf("localhost")>=0){
  URLHOST="http://124.30.96.19";
}
console.log(URLHOST);
export const environment = {
  production: false,  
  LogoutURL:URLHOST+"/ReportsPortal/#/login?type=",
  LoginURL:URLHOST+"/ReportsPortal/#/login?type=",
//  APIURL :URLHOST+"/reportsportalapi/api/v1/",  
    APIURL: "https://reports.aarthiscan.com/reportsportalapi/api/v1/",
  RADIOLOGISTAPI : "https://reports.aarthiscan.com/Freedom.PhysicianAccess/api/patient/",
  
};
